const initialReasonForRejection = {
  reasonForRejectionPermissions: {},
  reasonForRejectionLists: [],
  reasonForRejectionStatus: [],
  changedReasonForRejectionStatus: [],
  loadingReasonForRejection: false,
  errorsReasonForRejection: {},
};

const reasonForRejectionReducer = (reasonForRejection = initialReasonForRejection, action) => {
  switch (action.type) {
    case "GET_REASONFORREJECTIONLIST_PENDING":
    case "ADD_REASON_FOR_REJECTION_PENDING":
    case "UPDATE_REASON_FOR_REJECTION_PENDING":
    case "UPDATE_REASON_FOR_REJECTION_STATUS_PENDING":
    case "DELETE_REASON_FOR_REJECTION_PENDING":
    case "GET_REASONFORREJECTIONLISTBYID_PENDING":
      return { ...reasonForRejection, loadingReasonForRejection: true };

    case "GET_REASONFORREJECTIONLIST_FULFILLED":
      return {
        ...reasonForRejection,
        loadingReasonForRejection: false,
        reasonForRejectionLists: action.payload,
        reasonForRejectionCount: action.count,
        reasonForRejectionPermissions: action.permissions,
      };

    case "ADD_REASON_FOR_REJECTION_FULFILLED":
    case "UPDATE_REASON_FOR_REJECTION_FULFILLED":
    case "UPDATE_REASON_FOR_REJECTION_STATUS_FULFILLED":
    case "DELETE_REASON_FOR_REJECTION_FULFILLED":
      return {
        ...reasonForRejection,
        loadingReasonForRejection: false,
        changedReasonForRejectionStatus: action.payload,
      };

    case "GET_REASONFORREJECTIONLISTBYID_FULFILLED":
      return {
        ...reasonForRejection,
        loadingReasonForRejection: false,
        reasonForRejectionLists: action.payload,
      };

    case "RESET_DELETE_REASON_FOR_REJECTION_STATUS":
      return {
        ...reasonForRejection,
        loadingReasonForRejection: false,
        reasonForRejectionStatus: {},
        changedReasonForRejectionStatus: [],
        errorsReasonForRejection: {},
      };

    case "GET_REASONFORREJECTIONLIST_REJECTED":
    case "ADD_REASON_FOR_REJECTION_REJECTED":
    case "UPDATE_REASON_FOR_REJECTION_REJECTED":
    case "UPDATE_REASON_FOR_REJECTION_STATUS_REJECTED":
    case "DELETE_REASON_FOR_REJECTION_REJECTED":
    case "GET_REASONFORREJECTIONLISTBYID_REJECTED":
      return {
        ...reasonForRejection,
        loadingReasonForRejection: false,
        errorsReasonForRejection: action.payload,
      };

    default:
      return reasonForRejection;
  }
};

export default reasonForRejectionReducer;
